// Mock data for 24BETBOX clone. Replace with backend later.

export const siteInfo = {
  name: '24BETBOX',
  domain: '24betbox.com',
  email: 'support@24betbox.com',
  tagline: 'VIP Premium Football Predictions',
};

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: "Today's Tips", to: '/football-predictions-today' },
  { label: 'Full Archive', to: '/singles-archive' },
  { label: 'Blog', to: '/blog' },
  { label: 'Plans & Pricing', to: '/pricing' },
  { label: 'About Us', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

export const heroImages = {
  stadium: 'https://images.unsplash.com/photo-1599158150601-1417ebbaafdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxzb2NjZXIlMjBzdGFkaXVtJTIwbmlnaHR8ZW58MHx8fHwxNzg1NjE2NDAwfDA&ixlib=rb-4.1.0&q=85',
  player: 'https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxmb290YmFsbCUyMGFjdGlvbnxlbnwwfHx8fDE3ODU2MTcxNzZ8MA&ixlib=rb-4.1.0&q=85',
  ball: 'https://images.pexels.com/photos/30651230/pexels-photo-30651230.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  tactics: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxzb2NjZXIlMjB0YWN0aWNzfGVufDB8fHx8MTc4NTYxNjQwMHww&ixlib=rb-4.1.0&q=85',
  crowd: 'https://images.unsplash.com/photo-1517747614396-d21a78b850e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxzb2NjZXIlMjB0YWN0aWNzfGVufDB8fHx8MTc4NTYxNjQwMHww&ixlib=rb-4.1.0&q=85',
};

export const pricingPlans = [
  {
    id: 'weekly',
    badge: 'Most Popular',
    name: '7 Daily Tips',
    subtitle: 'One premium single tip every day for a full week',
    price: 119,
    period: '7 days',
    features: [
      'Daily single match (odds 2.00 – 4.00)',
      'Delivered every day before kickoff',
      'Detailed reasoning behind each pick',
      'Full statistical breakdown for each tip',
      'Priority email support',
    ],
    highlight: false,
  },
  {
    id: 'monthly',
    badge: 'Best Value',
    name: '30 Daily Tips',
    subtitle: 'One premium single tip every day for a full month',
    price: 399,
    period: '30 days',
    features: [
      'Daily single match (odds 2.00 – 4.00)',
      'Delivered every day before kickoff',
      'Full statistical breakdown for each tip',
      'VIP priority email support',
      'Free replacement tip on any rare loss',
    ],
    highlight: true,
  },
];

export const steps = [
  { title: 'Choose Your Plan', desc: 'Pick the 7 or 30 daily tips package that fits your betting goals.' },
  { title: 'Confirm By Email', desc: 'Send us a message through the contact form and we reply with details.' },
  { title: 'Receive Daily Tips', desc: 'Get expertly analysed predictions delivered before every kickoff.' },
  { title: 'Bet Smart, Win More', desc: 'Follow a disciplined strategy and grow your bankroll steadily.' },
];

export const features = [
  { title: 'Verified Professional Tipsters', desc: 'A team of 10 analysts, each with 10+ years tracking football markets.' },
  { title: 'Data-Driven Analysis', desc: 'Form, team news, tactical matchups, injuries and market movement — every angle covered.' },
  { title: 'Transparent Results', desc: 'Every pick is published openly in our public archive, wins and losses alike.' },
  { title: 'Disciplined Value Betting', desc: 'We only release a selection when the value and confidence are optimal.' },
];

export const nextSingle = {
  league: 'EUROPA Conference League',
  match: 'Din Minsk – Neftci Baku',
  tip: '2',
  odd: '2.00',
  result: '0:1',
  status: 'WON',
  date: '29.07.2026',
};

export const nextVipTicket = {
  title: 'NEXT VIP TICKET',
  price: 39,
  dateRange: '01/02.08.2026 (Saturday/Sunday)',
  totalMatches: 4,
  oddRange: '6.00 – 9.00',
  note: 'Delivered Friday, covering the biggest weekend action (Fri, Sat & Sun).',
};

// Single Tips Archive (24BETBOX style)
export const singlesArchive = [
  { date: '29.07.2026', league: 'Europa Conference League', match: 'Din Minsk – Neftci Baku', tip: '2', odd: '2.00', score: '0:1', result: 'WON' },
  { date: '28.07.2026', league: 'Sweden: Allsvenskan', match: 'Djurgarden – Halmstad', tip: '1', odd: '1.65', score: '3:0', result: 'WON' },
  { date: '27.07.2026', league: 'Norway: Eliteserien', match: 'Bodo/Glimt – Sarpsborg', tip: 'Over 2.5', odd: '1.72', score: '4:1', result: 'WON' },
  { date: '26.07.2026', league: 'Denmark: Superliga', match: 'Nordsjaelland – Horsens', tip: '1', odd: '1.55', score: '1:2', result: 'LOST' },
  { date: '25.07.2026', league: 'Finland: Veikkausliiga', match: 'HJK – VPS', tip: '1', odd: '1.40', score: '2:0', result: 'WON' },
  { date: '24.07.2026', league: 'Poland: Ekstraklasa', match: 'Lech Poznan – Radomiak', tip: '1', odd: '1.60', score: '3:1', result: 'WON' },
  { date: '23.07.2026', league: 'World: Europa League', match: 'Qarabag – Ludogorets', tip: 'X2', odd: '1.85', score: '1:1', result: 'WON' },
  { date: '22.07.2026', league: 'World: Conference League', match: 'Bohemians – Balkany', tip: '1', odd: '1.70', score: '2:0', result: 'WON' },
  { date: '21.07.2026', league: 'World: Champions League', match: 'Mjallby – Lincoln', tip: '1', odd: '1.45', score: '3:0', result: 'WON' },
  { date: '20.07.2026', league: 'Iceland: Pepsideild', match: 'Keflavik – Akranes', tip: 'Over 2.5', odd: '1.80', score: '1:1', result: 'LOST' },
  { date: '19.07.2026', league: 'Estonia: Meistriliiga', match: 'Narva – Parnu JK Vaprus', tip: 'Over 2.5', odd: '1.75', score: '3:1', result: 'WON' },
  { date: '18.07.2026', league: 'Lebanon: Premier League', match: 'Al Ansar – Jwayya', tip: '1', odd: '1.50', score: '2:0', result: 'WON' },
  { date: '17.07.2026', league: 'Ireland: Premier Division', match: 'Shamrock Rovers – Derry City', tip: '1', odd: '1.65', score: '2:1', result: 'WON' },
  { date: '16.07.2026', league: 'World: Conference League', match: 'Inter Turku – Sarajevo', tip: '1', odd: '1.60', score: '2:0', result: 'WON' },
  { date: '15.07.2026', league: 'Wales: Premier League', match: 'The New Saints – Bala Town', tip: '1', odd: '1.35', score: '4:0', result: 'WON' },
  { date: '14.07.2026', league: 'World: Champions League', match: 'Iberia – Flora', tip: '1', odd: '1.90', score: '0:1', result: 'LOST' },
  { date: '13.07.2026', league: 'Sweden: Superettan', match: 'Orgryte – Trelleborg', tip: 'Over 2.5', odd: '1.70', score: '3:2', result: 'WON' },
  { date: '12.07.2026', league: 'Norway: OBOS-ligaen', match: 'Bryne – Sandnes Ulf', tip: '1X', odd: '1.40', score: '2:2', result: 'WON' },
  { date: '11.07.2026', league: 'World: World Cup', match: 'Argentina – Switzerland', tip: '1', odd: '1.55', score: '2:1', result: 'WON' },
  { date: '10.07.2026', league: 'World: World Cup', match: 'Spain – Belgium', tip: '1', odd: '1.60', score: '1:1', result: 'LOST' },
  { date: '09.07.2026', league: 'World: World Cup', match: 'France – Morocco', tip: '1', odd: '1.70', score: '2:0', result: 'WON' },
  { date: '08.07.2026', league: 'Denmark: 1st Division', match: 'Fredericia – Koge', tip: '1', odd: '1.75', score: '2:1', result: 'WON' },
  { date: '07.07.2026', league: 'Estonia: Esiliiga', match: 'Tallinna Kalev – Kuressaare', tip: 'Over 2.5', odd: '1.65', score: '3:1', result: 'WON' },
  { date: '06.07.2026', league: 'World: World Cup', match: 'Portugal – Spain', tip: 'X2', odd: '1.80', score: '0:2', result: 'WON' },
];

// VIP Tickets Archive (24BETBOX style)
export const vipArchive = [
  {
    id: 1,
    dateRange: '18/19.07.2026 (Saturday/Sunday)',
    totalOdds: '6.82',
    status: 'WON',
    matches: [
      { date: '18.07.2026', match: 'Al Ansar – Jwayya', tip: '1', odds: '1.50', result: '2:0 Won' },
      { date: '18.07.2026', match: 'Patka Chakra – United Kolkota', tip: '2', odds: '1.30', result: '0:4 Won' },
      { date: '19.07.2026', match: 'Bulls Academy – Bankstown City Lions', tip: '2', odds: '2.00', result: '0:5 Won' },
      { date: '19.07.2026', match: 'Narva – Parnu JK Vaprus', tip: 'Over 2.5', odds: '1.75', result: '3:1 Won' },
    ],
  },
  {
    id: 2,
    dateRange: '11/12.07.2026 (Saturday/Sunday)',
    totalOdds: '7.40',
    status: 'WON',
    matches: [
      { date: '11.07.2026', match: 'Argentina – Switzerland', tip: '1', odds: '1.55', result: '2:1 Won' },
      { date: '11.07.2026', match: 'HJK – VPS', tip: '1', odds: '1.40', result: '2:0 Won' },
      { date: '12.07.2026', match: 'Bodo/Glimt – Sarpsborg', tip: 'Over 2.5', odds: '1.72', result: '4:1 Won' },
      { date: '12.07.2026', match: 'Djurgarden – Halmstad', tip: '1', odds: '1.95', result: '3:0 Won' },
    ],
  },
  {
    id: 3,
    dateRange: '04/05.07.2026 (Saturday/Sunday)',
    totalOdds: '8.15',
    status: 'WON',
    matches: [
      { date: '04.07.2026', match: 'Canada – Morocco', tip: '2', odds: '1.85', result: '0:2 Won' },
      { date: '04.07.2026', match: 'Australia – Egypt', tip: '1X', odds: '1.55', result: '1:1 Won' },
      { date: '05.07.2026', match: 'Goteborg – AIK', tip: 'X2', odds: '1.70', result: '0:1 Won' },
      { date: '05.07.2026', match: 'The New Saints – Bala Town', tip: '1', odds: '1.66', result: '4:0 Won' },
    ],
  },
  {
    id: 4,
    dateRange: '27/28.06.2026 (Saturday/Sunday)',
    totalOdds: '6.10',
    status: 'LOST',
    matches: [
      { date: '27.06.2026', match: 'Rosenborg – Molde', tip: '1', odds: '1.75', result: '1:2 Lost' },
      { date: '27.06.2026', match: 'Malmo – Hacken', tip: '1', odds: '1.60', result: '3:1 Won' },
      { date: '28.06.2026', match: 'Shamrock Rovers – Derry City', tip: 'Over 2.5', odds: '1.72', result: '2:1 Won' },
      { date: '28.06.2026', match: 'Lech Poznan – Radomiak', tip: '1', odds: '1.35', result: '2:0 Won' },
    ],
  },
  {
    id: 5,
    dateRange: '20/21.06.2026 (Saturday/Sunday)',
    totalOdds: '7.88',
    status: 'WON',
    matches: [
      { date: '20.06.2026', match: 'Vikingur – Breidablik', tip: 'X2', odds: '1.80', result: '1:2 Won' },
      { date: '20.06.2026', match: 'Sheriff – Petrocub', tip: '1', odds: '1.55', result: '2:0 Won' },
      { date: '21.06.2026', match: 'Ludogorets – CSKA Sofia', tip: '1', odds: '1.50', result: '3:1 Won' },
      { date: '21.06.2026', match: 'Bohemians – Balkany', tip: 'Over 2.5', odds: '1.88', result: '3:2 Won' },
    ],
  },
  {
    id: 6,
    dateRange: '13/14.06.2026 (Saturday/Sunday)',
    totalOdds: '6.55',
    status: 'WON',
    matches: [
      { date: '13.06.2026', match: 'Rijeka – Hajduk Split', tip: '1', odds: '1.70', result: '2:1 Won' },
      { date: '13.06.2026', match: 'Dinamo Zagreb – Osijek', tip: '1', odds: '1.40', result: '3:0 Won' },
      { date: '14.06.2026', match: 'Lugano – Sion', tip: '1', odds: '1.65', result: '2:0 Won' },
      { date: '14.06.2026', match: 'Young Boys – Servette', tip: 'Over 2.5', odds: '1.66', result: '4:1 Won' },
    ],
  },
];

export const reviews = [
  {
    name: 'Brian Otieno',
    country: 'Kenya',
    title: 'These people know their stuff',
    text: 'I had been burned by scam sites for years until I tried 24BETBOX. I asked for a two-week subscription — two years later I am still a member. This is a team I trust. Incredible service and 24/7 support.',
  },
  {
    name: 'Joseph Otieno',
    country: 'Kenya',
    title: 'Impressive consistency',
    text: 'They clearly state they offer predictions — not guarantees — yet their accuracy is outstanding. Their work made it noticeably easier for me to profit. Highly recommend.',
  },
  {
    name: 'Samuel Mwangi',
    country: 'Kenya',
    title: 'Honest team, reliable tips',
    text: 'Joining 24BETBOX changed how I approach football predictions. The team is transparent, they publish results openly, and their guidance has generated real returns for me.',
  },
  {
    name: 'Kwame Mensah',
    country: 'Ghana',
    title: 'Upfront about predictions',
    text: 'Refreshingly transparent — they clearly distinguish tips from promises. The match accuracy is incredible. Once you see the archives, confidence follows quickly.',
  },
  {
    name: 'Ettore Mancini',
    country: 'Italy',
    title: 'Real, dependable football tips',
    text: 'I subscribed to the daily tips for two weeks and finally feel I have found a reliable source after many scams. The predictions are solid and the approach is professional.',
  },
];

export const stats = [
  { value: '10+', label: 'Professional Tipsters' },
  { value: '10 yrs', label: 'Average Experience' },
  { value: '92%', label: 'Archived Win Rate' },
  { value: '10h+', label: 'Daily Research' },
];
